import cTooltip from "../modules/cTooltip/tooltipManager";

/**
 * Modifiers
 *  - wrap -
 *    useful when the element with a tooltip is disabled which prevent mouse events from working
 *    wraps the element in a <div> and puts tooltip on it instead
 */
export default {
  inserted: (el, binding, vnode) => {
    let tooltipElement
    if (binding.modifiers.wrap) {
      let wrappingFunction
      if (binding.modifiers.span) {
        wrappingFunction = () => `<span class="tooltip-wrap"></span>`
      } else {
        wrappingFunction = () => `<div class="tooltip-wrap"></div>`
      }
      tooltipElement = $(el).wrap(wrappingFunction).parent()[0]
      el.tooltipElement = tooltipElement
    } else {
      tooltipElement = el
    }
    tooltipElement.tooltip = new cTooltip({ html: binding.arg?.html }).init($(tooltipElement), binding.value);
  },
  update: (el, binding, vnode) => {
    const tooltip = getTooltipElement(el)['tooltip'];
    if (tooltip) {
      tooltip.updateTooltipText(binding.value);
    }
  },
  unbind: (el, binding, vnode) => {
    const tooltip = getTooltipElement(el)['tooltip'];
    if (tooltip) {
      tooltip.deleteTooltipContainer()
    }
  },
}

const getTooltipElement = el => {
  return el.tooltipElement || el
}